function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.38,236.13s-20.55,10.48-25.28,15.62-1,9.86.82,15.2,25.93,35.93,27.78,37.37,11.3-3.08,24.05-8.63,15.82-7.81,15.82-10.89-16.48-53-17.5-55.25S171.72,233,166.38,236.13Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.32,228.32a5.14,5.14,0,0,0-1.23,3.9c.41,2.06,2.47,10.07,2.26,12.74s-2.67,3.09-7.81,1-8.42-8-9.25-9.45-4.11-10.07-4.11-10.07l2.26-1.44s2.27,3.49,7.81,3.49,9.46-2.88,10.07-1.64S179.32,228.32,179.32,228.32Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.16,222s-6.17-8.23-6-10.69,13.05-11.81,16.55-11.19,9,11.08,9,11.08l3.09,3.09-1,2.88s5.27,7.29,4.65,8.32-5.34,3.9-11.1,5.14-11.3-2.47-11.3-2.47-3.9,1.64-5.55.62-3.9-4.73-3.49-5.55S158.16,222,158.16,222Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.15,259.07c.28,6.2,5.65,10.61,9,12.76a9.18,9.18,0,0,0,5.11,1.46L213,272.5V259.35l-64.53-9s-5.13.2-6.51,4.06",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.77,305.13a2.24,2.24,0,0,1-1.4-.38c-1.45-1.13-26-32-28-37.62-.36-1-.8-2.06-1.22-3.06-1.73-4.08-3.52-8.31.51-12.69,4.72-5.13,24.41-15.22,25.42-15.73,5.06-2.91,22.06-8.12,25.6-7a1.27,1.27,0,0,1,.84.67c1.14,2.5,17.55,52.36,17.55,55.47,0,3.46-3.32,5.8-16.15,11.39-1.76.76-3.46,1.51-5.08,2.23C179.14,302.7,173.48,305.12,170.77,305.13Zm19.68-75.61c-4.25,0-18.72,4.14-23.8,7.08h0c-.2.1-20.52,10.49-25.12,15.5-3.56,3.87-2.06,7.42-.31,11.54.43,1,.87,2.06,1.24,3.13,1.93,5.58,26.17,36,27.6,37.11s9.63-2.6,18.41-6.47l5.09-2.23c12-5.23,15.5-7.57,15.5-10.39,0-2.64-16.09-52-17.46-55C191.43,229.6,191,229.52,190.45,229.52Zm-24.07,6.61h0Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path--inject-11)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.66,247.84a15.36,15.36,0,0,1-5.32-1.35c-3.44-1.37-6.61-4.59-9.45-9.56l-.07-.12c-.83-1.46-4-9.8-4.14-10.15a.55.55,0,0,1,.21-.65l2.26-1.44a.55.55,0,0,1,.75.16c.09.13,2.19,3.25,7.35,3.25a22.17,22.17,0,0,0,7-1.35c1.76-.58,3-1,3.54,0a2,2,0,0,1,.24,1.64,1,1,0,0,1-.37.46,4.51,4.51,0,0,0-1.06,3.37c.09.44.25,1.14.45,2,.74,3.26,2,8.71,1.82,10.89a2.81,2.81,0,0,1-1.26,2.35A3.55,3.55,0,0,1,177.66,247.84Zm-17.81-21.15c.66,1.73,3.22,8.37,3.91,9.58l.07.12c2.71,4.76,5.71,7.82,8.91,9.1,3.95,1.57,5.61,1.38,6.32.94a1.77,1.77,0,0,0,.75-1.51c.16-2-1.12-7.58-1.8-10.57-.2-.87-.36-1.58-.45-2a5.64,5.64,0,0,1,1.36-4.37.45.45,0,0,1,.13-.11,1.29,1.29,0,0,0-.21-.73,6.94,6.94,0,0,0-2.24.54,23.15,23.15,0,0,1-7.35,1.4,10.06,10.06,0,0,1-7.93-3.31Zm19.3,1.11Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-2--inject-11)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.91,231.37a18.27,18.27,0,0,1-8.9-2.65c-1,.38-4.16,1.48-5.78.47s-4.34-5-3.7-6.25c.39-.79,2.56-1.21,4.63-1.44-1.6-2.2-5.69-8.07-5.5-10.29.12-1.5,3.33-4.18,5.23-5.65,3-2.29,9.29-6.5,12-6,3.58.63,8.61,9.9,9.34,11.29l3,3a.52.52,0,0,1,.12.57l-.93,2.61c3.52,4.89,5,7.81,4.52,8.68-.72,1.19-5.6,4.13-11.45,5.39A12.66,12.66,0,0,1,170.91,231.37Zm-8.85-3.8a.53.53,0,0,1,.3.09c.06,0,5.43,3.56,10.89,2.39,5.89-1.26,10.29-4.13,10.75-4.89.07-.68-2.34-4.56-4.63-7.72a.53.53,0,0,1-.07-.5l.91-2.56-2.85-2.84a.71.71,0,0,1-.1-.14c-1.49-2.84-6-10.33-8.61-10.8-1.62-.28-6.5,2.27-11.1,5.82-3.24,2.49-4.76,4.28-4.81,4.88-.14,1.65,3.51,7.21,5.85,10.32a.55.55,0,0,1,.06.55.52.52,0,0,1-.45.31c-2.25.2-4.42.64-4.72,1-.1.58,1.75,3.84,3.32,4.82,1.15.72,4.11-.26,5-.66A.52.52,0,0,1,162.06,227.57Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-3--inject-11)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.12,273.83a9.67,9.67,0,0,1-5.28-1.55c-3.32-2.14-8.93-6.7-9.23-13.19a.55.55,0,0,1,.52-.57.53.53,0,0,1,.56.52c.28,6,5.59,10.31,8.74,12.33a8.39,8.39,0,0,0,4.81,1.38l59.25-.78V259.82l-64.07-9c.05,0-4.68.25-5.92,3.71a.54.54,0,0,1-.69.33.56.56,0,0,1-.33-.7c1.48-4.15,6.77-4.41,7-4.41l64.62,9a.55.55,0,0,1,.47.54V272.5a.54.54,0,0,1-.53.54l-59.79.79Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-4--inject-11)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.76,165.75c-8.45-10.11-17.34-20-25.44-30.41C325.6,104.8,294.4,75.39,255,67.17,215.11,58.85,167.63,73,143.56,107c-16,22.59-22.25,50.66-22.81,78-.25,12.48,1.89,25.09-.12,37.5-2.22,13.65-9.88,25.62-16.58,37.45-8.86,15.65-12.68,32.88-7.3,50.52,12.17,39.85,67.12,58.37,104.87,51.7,20.58-3.64,39.44-13.61,59.38-19.9,16.44-5.19,33.36-6.7,50.07-1.74,38.08,11.3,77.08-8.18,93.21-44,19.47-43.24,1.25-92.34-26.64-127.23C376.69,168.08,375.74,166.91,374.76,165.75Z",
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.76,165.75c-8.45-10.11-17.34-20-25.44-30.41C325.6,104.8,294.4,75.39,255,67.17,215.11,58.85,167.63,73,143.56,107c-16,22.59-22.25,50.66-22.81,78-.25,12.48,1.89,25.09-.12,37.5-2.22,13.65-9.88,25.62-16.58,37.45-8.86,15.65-12.68,32.88-7.3,50.52,12.17,39.85,67.12,58.37,104.87,51.7,20.58-3.64,39.44-13.61,59.38-19.9,16.44-5.19,33.36-6.7,50.07-1.74,38.08,11.3,77.08-8.18,93.21-44,19.47-43.24,1.25-92.34-26.64-127.23C376.69,168.08,375.74,166.91,374.76,165.75Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 248.24,
    cy: 401.48,
    rx: 142.83,
    ry: 27.6,
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 248.24,
    cy: 401.48,
    rx: 142.83,
    ry: 27.6,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--progress-bar--inject-11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198.33,
    y: 283.33,
    width: 116.67,
    height: 18,
    rx: 4.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.33,301.83H203a5.17,5.17,0,0,1-5.17-5.16V288a5.18,5.18,0,0,1,5.17-5.17H310.33A5.18,5.18,0,0,1,315.5,288v8.67A5.17,5.17,0,0,1,310.33,301.83ZM203,283.83a4.17,4.17,0,0,0-4.17,4.17v8.67a4.17,4.17,0,0,0,4.17,4.16H310.33a4.17,4.17,0,0,0,4.17-4.16V288a4.17,4.17,0,0,0-4.17-4.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 285.21,
    width: 7.33,
    height: 14.79,
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.14,
    y: 285.21,
    width: 7.33,
    height: 14.79,
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.28,
    y: 285.21,
    width: 7.33,
    height: 14.79,
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.42,
    y: 285.21,
    width: 7.33,
    height: 14.79,
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.56,
    y: 285.21,
    width: 7.33,
    height: 14.79,
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.7,
    y: 285.21,
    width: 7.33,
    height: 14.79,
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.84,
    y: 285.21,
    width: 7.33,
    height: 14.79,
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.98,
    y: 285.21,
    width: 7.33,
    height: 14.79,
    style: {
      fill: "#CD7070"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.71,161l9.61-4.38-2-11.54-10.6-.82a46.1,46.1,0,0,0-5.31-10l5.47-9.23-8.29-8.29-9.3,5.53A46.13,46.13,0,0,0,234.49,115l-2.68-10.63H220.09l-2.7,10.69a46.36,46.36,0,0,0-10.53,3.35l-8.38-7.25-9.59,6.72,4,10.37a46.58,46.58,0,0,0-6.73,8.73l-11-1.14-4,11,9.13,6.19a46.41,46.41,0,0,0-.66,7.78c0,1.11,0,2.2.13,3.29l-9.61,5.36,3,11.32,10.88-.14a46.9,46.9,0,0,0,6,9.5l-4.7,9.75,9,7.53,8.7-6.23a46.21,46.21,0,0,0,10.47,4.43l1.75,10.49,11.67,1,3.52-9.93a46.07,46.07,0,0,0,11.23-2.44l7.36,7.49,10.15-5.86-2.79-10.09a46.62,46.62,0,0,0,7.8-8.5l10.31,1.9,5-10.61-8.09-6.68A46.13,46.13,0,0,0,272.71,161Zm-17.33-.2a29.25,29.25,0,1,1-29.25-29.25A29.25,29.25,0,0,1,255.38,160.81Z",
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.82,217.67h0l-11.67-1a.54.54,0,0,1-.49-.45L212.92,206a47.08,47.08,0,0,1-10-4.2l-8.42,6a.53.53,0,0,1-.66,0l-9-7.53a.54.54,0,0,1-.14-.65l4.54-9.45a47.49,47.49,0,0,1-5.67-9l-10.53.13a.52.52,0,0,1-.53-.4l-3-11.32a.53.53,0,0,1,.25-.61l9.31-5.2c-.07-1.12-.1-2.07-.1-3a47,47,0,0,1,.61-7.53l-8.85-6a.55.55,0,0,1-.2-.64l4-11a.56.56,0,0,1,.57-.35l10.69,1.1a46.85,46.85,0,0,1,6.38-8.28l-3.83-10.05a.52.52,0,0,1,.2-.63l9.59-6.72a.54.54,0,0,1,.67,0l8.11,7a47.09,47.09,0,0,1,10-3.17l2.61-10.36a.56.56,0,0,1,.53-.41h11.72a.54.54,0,0,1,.52.41l2.6,10.29a46.62,46.62,0,0,1,17.35,7.08l9-5.35a.53.53,0,0,1,.66.08l8.28,8.28a.55.55,0,0,1,.08.66L265,134.2a47.26,47.26,0,0,1,5.05,9.56l10.26.79a.54.54,0,0,1,.49.45l2,11.54a.56.56,0,0,1-.31.59l-9.3,4.23a47,47,0,0,1-1.38,10.85l7.82,6.46a.54.54,0,0,1,.15.64l-4.95,10.62a.55.55,0,0,1-.59.31l-10-1.84a48.27,48.27,0,0,1-7.42,8.09l2.69,9.75a.55.55,0,0,1-.25.62l-10.15,5.86a.55.55,0,0,1-.65-.09l-7.13-7.24a46.87,46.87,0,0,1-10.69,2.31l-3.4,9.61A.55.55,0,0,1,226.82,217.67Zm-11.21-2.06,10.84.94,3.38-9.54a.52.52,0,0,1,.46-.35,45.65,45.65,0,0,0,11.1-2.41.55.55,0,0,1,.57.13l7.07,7.19,9.42-5.44-2.68-9.69a.52.52,0,0,1,.17-.55,46.59,46.59,0,0,0,7.71-8.4.54.54,0,0,1,.54-.22l9.89,1.82,4.6-9.85-7.76-6.41a.52.52,0,0,1-.18-.56A46.15,46.15,0,0,0,272.17,161a.54.54,0,0,1,.32-.49l9.23-4.21-1.89-10.71-10.19-.79a.53.53,0,0,1-.46-.35,45.71,45.71,0,0,0-5.24-9.92.55.55,0,0,1,0-.59l5.25-8.87-7.69-7.69-8.94,5.31a.53.53,0,0,1-.58,0,45.73,45.73,0,0,0-17.56-7.16.54.54,0,0,1-.43-.4l-2.59-10.22H220.51l-2.59,10.29a.55.55,0,0,1-.43.4,46,46,0,0,0-10.41,3.3.54.54,0,0,1-.58-.08l-8.05-7-8.91,6.23,3.81,10a.54.54,0,0,1-.12.57,46.61,46.61,0,0,0-6.65,8.63.55.55,0,0,1-.52.26l-10.61-1.09-3.72,10.22,8.78,6a.53.53,0,0,1,.23.54,46.78,46.78,0,0,0-.65,7.69c0,1,0,2,.13,3.25a.56.56,0,0,1-.28.51l-9.24,5.16,2.82,10.5L184,180.1h0a.54.54,0,0,1,.49.31,46,46,0,0,0,5.9,9.39.54.54,0,0,1,.07.57l-4.52,9.38,8.33,7,8.36-6a.55.55,0,0,1,.59,0,46.21,46.21,0,0,0,10.35,4.37.54.54,0,0,1,.39.43Zm10.52-25a29.79,29.79,0,1,1,29.8-29.79A29.83,29.83,0,0,1,226.13,190.6Zm0-58.5a28.71,28.71,0,1,0,28.71,28.71A28.74,28.74,0,0,0,226.13,132.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.06,183.84a1.62,1.62,0,0,1-1.54-1.13,68.85,68.85,0,0,1-2.46-10.32,1.62,1.62,0,1,1,3.21-.5,66.29,66.29,0,0,0,2.34,9.83,1.63,1.63,0,0,1-1.05,2A1.45,1.45,0,0,1,162.06,183.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.87,165a1.63,1.63,0,0,1-1.63-1.58c0-.63,0-1.26,0-1.89A69.25,69.25,0,0,1,279,116.4a1.62,1.62,0,1,1-2.46,2.12,66,66,0,0,0-116.07,43c0,.6,0,1.2,0,1.8a1.62,1.62,0,0,1-1.58,1.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.31 111.32 284.1 126.12 270.39 120.28 282.31 111.32",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear-2--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.22,213.69l8.21-2.45-2.12-12-8.61.52a38.8,38.8,0,0,0-4.41-8.36l5.41-6.82L342.08,176l-6.88,5.46a38.49,38.49,0,0,0-14.78-6l-1-8.84H307.22l-1,8.9a38.66,38.66,0,0,0-8.77,2.78l-6-6.73-10,7,4.29,7.93a38.82,38.82,0,0,0-5.6,7.26l-8.76-2.09L267.24,203l8,4a38.25,38.25,0,0,0-.55,6.47c0,.92,0,1.83.11,2.74l-8.31,3.28,3.15,11.77,8.73-1.29a38.66,38.66,0,0,0,5,7.9l-4.84,7.33,9.34,7.83,6.3-6a38.64,38.64,0,0,0,8.72,3.68l.23,8.62,12.14,1.06,1.72-8.37a38.67,38.67,0,0,0,9.34-2l5.07,6.83,10.55-6.09-3.37-7.78a39.59,39.59,0,0,0,6.49-7.07l8.06,2.68,5.15-11L351,223.17A38.48,38.48,0,0,0,352.22,213.69Zm-14.42-.17a24.34,24.34,0,1,1-24.33-24.34A24.33,24.33,0,0,1,337.8,213.52Z",
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.25,261h-.05L303.07,260a.54.54,0,0,1-.5-.52l-.22-8.23a39.07,39.07,0,0,1-8.11-3.42l-6,5.69a.54.54,0,0,1-.72,0l-9.34-7.83a.55.55,0,0,1-.1-.72l4.62-7a39.36,39.36,0,0,1-4.61-7.34l-8.34,1.24a.53.53,0,0,1-.6-.4L266,219.68a.54.54,0,0,1,.33-.64l7.94-3.14c-.06-.89-.08-1.65-.08-2.38a39.25,39.25,0,0,1,.49-6.17L267,203.52a.54.54,0,0,1-.27-.67l4.17-11.45a.56.56,0,0,1,.64-.34l8.37,2a39.33,39.33,0,0,1,5.19-6.73l-4.1-7.58a.54.54,0,0,1,.17-.7l10-7a.54.54,0,0,1,.72.09l5.7,6.43A38.86,38.86,0,0,1,305.7,175l1-8.5a.55.55,0,0,1,.54-.48h12.19a.54.54,0,0,1,.53.48l1,8.45a38.87,38.87,0,0,1,14.26,5.81l6.57-5.21a.55.55,0,0,1,.72,0l8.61,8.62a.54.54,0,0,1,0,.72l-5.16,6.5a39.32,39.32,0,0,1,4.11,7.77l8.21-.49a.55.55,0,0,1,.57.45l2.11,12a.53.53,0,0,1-.38.61l-7.82,2.33a39.55,39.55,0,0,1-1.12,8.83l6.9,4.24a.55.55,0,0,1,.21.69l-5.15,11a.55.55,0,0,1-.66.29l-7.69-2.56a39.6,39.6,0,0,1-6,6.58l3.21,7.42a.54.54,0,0,1-.22.68l-10.56,6.09a.53.53,0,0,1-.7-.14l-4.84-6.52a39.06,39.06,0,0,1-8.69,1.88l-1.64,8A.54.54,0,0,1,315.25,261Zm-11.61-2.11,11.18,1,1.61-7.9a.55.55,0,0,1,.49-.43,38.15,38.15,0,0,0,9.21-2,.55.55,0,0,1,.62.19l4.78,6.44,9.72-5.61-3.19-7.34a.56.56,0,0,1,.15-.63,37.76,37.76,0,0,0,6.39-7,.57.57,0,0,1,.62-.2l7.6,2.54,4.74-10.17-6.83-4.2a.55.55,0,0,1-.24-.6,38,38,0,0,0,1.19-9.35.53.53,0,0,1,.39-.51l7.74-2.31-1.95-11.05-8.12.49a.53.53,0,0,1-.54-.35,38.43,38.43,0,0,0-4.35-8.24.53.53,0,0,1,0-.64l5.1-6.44L342,176.69l-6.5,5.16a.53.53,0,0,1-.64,0,37.76,37.76,0,0,0-14.57-5.94.54.54,0,0,1-.44-.47l-1-8.37H307.7l-1,8.42a.52.52,0,0,1-.43.47,38,38,0,0,0-8.64,2.75.55.55,0,0,1-.63-.14l-5.65-6.36-9.19,6.43,4.06,7.5a.56.56,0,0,1-.09.64,37.88,37.88,0,0,0-5.52,7.16.57.57,0,0,1-.6.25l-8.29-2-3.83,10.54,7.58,3.79a.55.55,0,0,1,.29.58,38.43,38.43,0,0,0-.54,6.38c0,.81,0,1.67.11,2.7a.55.55,0,0,1-.34.54l-7.86,3.11,2.9,10.83,8.25-1.22a.54.54,0,0,1,.57.31,38.52,38.52,0,0,0,4.9,7.79.54.54,0,0,1,0,.64l-4.57,6.93,8.59,7.21,6-5.63a.53.53,0,0,1,.64-.08,37.75,37.75,0,0,0,8.59,3.63.54.54,0,0,1,.4.5Zm9.83-20.52a24.88,24.88,0,1,1,24.88-24.88A24.91,24.91,0,0,1,313.47,238.4Zm0-48.68a23.8,23.8,0,1,0,23.79,23.8A23.83,23.83,0,0,0,313.47,189.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.08,272.65a58.17,58.17,0,0,1-36.84-13.27,1.62,1.62,0,0,1,2.07-2.5A54.68,54.68,0,0,0,362.41,191a1.63,1.63,0,1,1,2.93-1.41,57.93,57.93,0,0,1-52.26,83.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.38 196.02 358.33 181.11 371.26 188.52 358.38 196.02",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.67,
    cy: 401.33,
    rx: 51.67,
    ry: 13,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.52,390.51c0-.58.07-1.16.07-1.76,0-14-13.15-25.32-29.38-25.32s-29.39,11.34-29.39,25.32c0,.6,0,1.18.08,1.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.52,391.06H225.9a.54.54,0,0,1-.54-.5c-.05-.68-.08-1.26-.08-1.81,0-14.26,13.43-25.86,29.93-25.86s29.93,11.6,29.93,25.86c0,.55,0,1.12-.08,1.81A.55.55,0,0,1,284.52,391.06ZM226.4,390H284c0-.44,0-.84,0-1.22,0-13.66-12.94-24.78-28.84-24.78s-28.85,11.12-28.85,24.78C226.36,389.14,226.38,389.53,226.4,390Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.52,392.92c0-.58.07-1.17.07-1.76,0-14-13.15-25.32-29.38-25.32s-29.39,11.34-29.39,25.32c0,.59,0,1.18.08,1.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.52,393.46H225.9a.54.54,0,0,1-.54-.49c-.05-.69-.08-1.26-.08-1.81,0-14.26,13.43-25.86,29.93-25.86s29.93,11.6,29.93,25.86c0,.55,0,1.12-.08,1.81A.54.54,0,0,1,284.52,393.46Zm-58.12-1.08H284c0-.44,0-.84,0-1.22,0-13.66-12.94-24.78-28.84-24.78s-28.85,11.12-28.85,24.78C226.36,391.54,226.38,391.94,226.4,392.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.07,229.55l20.21,31.95L234.49,249l1.35,10.84S214.45,276.67,211.47,278s-8.4.55-9.75-1.08S189,235,189,235,187,227.39,192.07,229.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.66,279.25c-2.62,0-5.33-.72-6.36-2-1.39-1.67-11.67-38-12.83-42.18-.13-.47-1.12-4.53.57-6,.75-.64,1.84-.67,3.24-.07a.49.49,0,0,1,.24.21l19.94,31.52,21.76-12.21a.54.54,0,0,1,.51,0,.57.57,0,0,1,.3.42l1.35,10.83a.53.53,0,0,1-.2.49c-.88.69-21.49,16.85-24.49,18.22A10.07,10.07,0,0,1,207.66,279.25ZM190.49,229.7a1.12,1.12,0,0,0-.74.24c-.89.77-.62,3.41-.24,4.89,4.53,16.06,11.63,40.46,12.63,41.77,1.18,1.41,6.36,2.18,9.1.93s21.66-16,24-17.89l-1.22-9.73L212.54,262a.54.54,0,0,1-.72-.19L191.7,230A3.51,3.51,0,0,0,190.49,229.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.41 247.42 217.97 257.17 226.18 273.15 239.09 259.07 237.74 244.17 233.41 247.42",
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.18,273.69h-.07a.59.59,0,0,1-.41-.29l-8.21-16a.54.54,0,0,1,.19-.71L233.1,247l4.31-3.23a.54.54,0,0,1,.87.38l1.35,14.9a.49.49,0,0,1-.14.41l-12.91,14.09A.54.54,0,0,1,226.18,273.69Zm-7.5-16.33,7.63,14.85,12.22-13.33-1.24-13.69-3.56,2.66,0,0Zm14.73-9.94h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.7,304.32l37.7,37.89s-9.48,8.94-16.25,16.53-17.87,17.33-17.87,17.33l3.79,4.6s43.88-33,46-35.21,2.17-6.5,1.63-12.18-16.52-50.38-16.52-50.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.07,381.22a.55.55,0,0,1-.42-.2l-3.79-4.61a.54.54,0,0,1,.06-.75c.11-.09,11.16-9.81,17.83-17.28,5.92-6.63,14-14.38,15.88-16.18l-37.31-37.5a.55.55,0,0,1-.16-.45.56.56,0,0,1,.28-.4L208,282.43a.57.57,0,0,1,.46,0,.58.58,0,0,1,.32.33c.65,1.82,16,44.82,16.55,50.5.58,6.12.48,10.36-1.78,12.63s-44.31,33.91-46.1,35.26A.59.59,0,0,1,177.07,381.22Zm-3-5.09,3.13,3.8c4.48-3.38,43.57-32.85,45.57-34.85s2-6.12,1.47-11.75c-.5-5.2-14.37-44.3-16.28-49.65l-37.33,20.77,37.2,37.38a.59.59,0,0,1,.16.39.61.61,0,0,1-.17.39c-.1.09-9.54,9-16.22,16.49C185.56,365.81,176.07,374.32,174,376.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.86,353.56,199,369.51l-18.52,9.69a11.21,11.21,0,0,0,0,6.55c1.14,3.14,4,6.27,4.27,8s.57,2.56-3.13,2.56-7.69-3.13-9.69-5.41-2.28-8.55-4-11.11-4.56-6.27-2.28-9.69,6.83-4,6.83-4Z",
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.6,396.83c-4.1,0-8.27-3.51-10.09-5.59-1.16-1.32-1.76-3.77-2.34-6.14a18.08,18.08,0,0,0-1.69-5l-.37-.55c-1.79-2.64-4.24-6.25-1.91-9.74,2.18-3.28,6.25-4.07,7.07-4.2l17.27-12.46A.58.58,0,0,1,190,353a.52.52,0,0,1,.35.26l9.12,16a.55.55,0,0,1,.05.42.51.51,0,0,1-.27.32l-18.32,9.58a10.59,10.59,0,0,0,.06,6,24.11,24.11,0,0,0,2.45,4.48,11.89,11.89,0,0,1,1.85,3.59l0,.18c.14.86.27,1.6-.23,2.19S183.6,396.83,181.6,396.83Zm8.09-42.48L172.8,366.53a.46.46,0,0,1-.25.1s-4.34.59-6.45,3.75c-1.92,2.88.2,6,1.9,8.53l.38.56a18.62,18.62,0,0,1,1.85,5.37c.54,2.24,1.11,4.56,2.09,5.68,2.2,2.52,6.05,5.23,9.28,5.23,1.51,0,2.4-.15,2.64-.44s.09-.69,0-1.31l0-.18a11.73,11.73,0,0,0-1.69-3.18,24.79,24.79,0,0,1-2.56-4.7,11.64,11.64,0,0,1,0-6.91.48.48,0,0,1,.26-.31l18-9.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.08,396c-4-1.15-7.71-4.35-10.25-7.84-2.84-3.9-2.13-10.65-5-13.13-1.74-1.53-1.88-4.53-1.73-6.61a7.82,7.82,0,0,0-1.48,1.64c-2.28,3.42.57,7.13,2.28,9.69s2,8.83,4,11.11,6,5.41,9.69,5.41A7.77,7.77,0,0,0,184.08,396Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.6,396.83c-4.1,0-8.27-3.51-10.09-5.59-1.16-1.32-1.76-3.77-2.34-6.14a18.08,18.08,0,0,0-1.69-5l-.37-.55c-1.79-2.64-4.24-6.25-1.91-9.74a8.21,8.21,0,0,1,1.59-1.76.55.55,0,0,1,.59-.07.53.53,0,0,1,.29.53c-.12,1.69-.09,4.73,1.55,6.16s2.14,3.92,2.71,6.59c.51,2.38,1,4.84,2.34,6.63,2.8,3.85,6.43,6.63,10,7.64a.53.53,0,0,1,.4.5.56.56,0,0,1-.36.53A8.23,8.23,0,0,1,181.6,396.83Zm-15-27a4.85,4.85,0,0,0-.45.59c-1.92,2.88.2,6,1.9,8.53l.38.56a18.62,18.62,0,0,1,1.85,5.37c.54,2.24,1.11,4.56,2.09,5.68,2.2,2.52,6.05,5.23,9.28,5.23h.22a22.5,22.5,0,0,1-8.43-7.25c-1.44-2-2-4.55-2.52-7s-1-4.84-2.37-6C167,374.12,166.56,371.83,166.55,369.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.6,299.87s7.31,13.46,13,21.31c7.58,10.47,21.3,26.45,21.3,26.45l-2.16,50.65,6.77.81s12.19-49.83,12.46-53.9-17.61-42.25-17.61-42.25",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.51,399.63h-.07l-6.77-.81a.54.54,0,0,1-.47-.57l2.15-50.43c-1.46-1.72-14.09-16.52-21.19-26.32-5.64-7.79-13-21.23-13-21.37a.54.54,0,0,1,.22-.73.53.53,0,0,1,.73.21c.08.14,7.37,13.52,13,21.25,7.48,10.34,21.14,26.26,21.28,26.42a.62.62,0,0,1,.13.37L199.3,397.8l5.8.7c1.23-5.08,12.08-49.58,12.33-53.34.21-3.22-12.6-31.4-17.56-42a.55.55,0,0,1,.26-.72.54.54,0,0,1,.72.26c1.84,3.92,17.93,38.44,17.66,42.52s-12,51.95-12.48,54A.53.53,0,0,1,205.51,399.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.85,348a.55.55,0,0,1-.55-.54c-.06-14.28-6-25.66-12.32-37.71l-1.17-2.24a.55.55,0,0,1,0-.47L207,299.8a.54.54,0,1,1,1,.43l-3,7,1,2c6.37,12.17,12.38,23.66,12.45,38.2a.55.55,0,0,1-.54.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.75,371h-.06a.54.54,0,0,1-.48-.59s.13-1.33.37-3.22a.53.53,0,0,1,.6-.47.53.53,0,0,1,.47.6c-.23,1.88-.36,3.19-.36,3.2A.55.55,0,0,1,204.75,371Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.59,364.13h-.07a.53.53,0,0,1-.46-.61c.68-4.85,1.32-7.91,1.91-9.09a2.26,2.26,0,0,0,.34-1.78c-.27-.57-1.27-.82-2.24-1.06a1,1,0,0,1-.81-.7c-.2-.78.7-1.6,2-2.84a14.62,14.62,0,0,0,2.5-2.69c.15-.25.11-.37.09-.41-.18-.55-1.62-1.15-3-1.72a19.86,19.86,0,0,1-5.54-3.05c-2.9-2.54-15.85-22.7-21.28-31.25a.55.55,0,0,1,.16-.75.54.54,0,0,1,.75.17c11.26,17.72,19.14,29.32,21.08,31a18.5,18.5,0,0,0,5.24,2.86c1.92.8,3.31,1.37,3.64,2.39a1.53,1.53,0,0,1-.19,1.31,15.15,15.15,0,0,1-2.69,2.92,12.09,12.09,0,0,0-1.66,1.71c1.2.3,2.44.62,2.91,1.65a3.12,3.12,0,0,1-.35,2.72c-.37.73-1,2.85-1.81,8.75A.55.55,0,0,1,205.59,364.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.44,307.49a.53.53,0,0,1-.46-.26l-1.24-2a.54.54,0,1,1,.91-.58l1.24,2a.54.54,0,0,1-.16.75A.52.52,0,0,1,178.44,307.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.77,371.62l17.76,1.5-4.82,25a11.24,11.24,0,0,0,6.93,6c5.11,1.5,7.22,2.4,7.22,4.81s-2.11,3-10.53,3.91-17.16-2.4-17.16-2.4-3.91-.61-4.21-3.31,3.91-10.24,3.91-10.24Z",
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.26,413.54A45,45,0,0,1,197,411c-.54-.09-4.28-.85-4.61-3.77-.3-2.7,3.25-9.25,3.91-10.44l.9-25.15a.54.54,0,0,1,.19-.39.53.53,0,0,1,.4-.13l17.76,1.5a.52.52,0,0,1,.38.21.56.56,0,0,1,.1.43L211.28,398a10.78,10.78,0,0,0,6.51,5.57c4.86,1.43,7.61,2.38,7.61,5.33s-2.86,3.58-11,4.45A29.77,29.77,0,0,1,211.26,413.54Zm-13-41.34-.89,24.71a.45.45,0,0,1-.07.25c-1.14,2-4.07,7.83-3.84,9.91.25,2.26,3.72,2.83,3.76,2.83l.1,0c.09,0,8.71,3.25,16.91,2.37,8.36-.89,10-1.46,10-3.37s-1.71-2.78-6.84-4.29a11.7,11.7,0,0,1-7.27-6.34.52.52,0,0,1,0-.3l4.7-24.39Zm-1.43,24.69h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.33,412.84c8-.85,10.3-1.44,10.51-3.57a45,45,0,0,1-14.81.92,53.6,53.6,0,0,1-16.82-5,5.39,5.39,0,0,0-.25,1.94c.3,2.7,4.21,3.31,4.21,3.31S205.9,413.75,214.33,412.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.26,413.54A45,45,0,0,1,197,411c-.54-.09-4.28-.85-4.61-3.77a6.22,6.22,0,0,1,.26-2.14.55.55,0,0,1,.3-.35.52.52,0,0,1,.47,0,53.29,53.29,0,0,0,16.65,4.94,43.5,43.5,0,0,0,14.62-.91.53.53,0,0,1,.48.13.54.54,0,0,1,.18.45c-.26,2.66-3.22,3.23-11,4.06A29.77,29.77,0,0,1,211.26,413.54ZM193.58,406a3.66,3.66,0,0,0-.08,1.09c.25,2.26,3.72,2.83,3.76,2.83l.1,0c.09,0,8.71,3.25,16.91,2.37h0c6.6-.7,9-1.22,9.77-2.31a43.53,43.53,0,0,1-14.08.73A54.07,54.07,0,0,1,193.58,406Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.38,236.13s-20.55,10.48-25.28,15.62-1,9.86.82,15.2,25.93,35.93,27.78,37.37,11.3-3.08,24.05-8.63,15.82-7.81,15.82-10.89-16.48-53-17.5-55.25S171.72,233,166.38,236.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.77,305.13a2.24,2.24,0,0,1-1.4-.38c-1.45-1.13-26-32-28-37.62-.36-1-.8-2.06-1.22-3.06-1.73-4.08-3.52-8.31.51-12.69,4.72-5.13,24.41-15.22,25.42-15.73,5.06-2.91,22.06-8.12,25.6-7a1.27,1.27,0,0,1,.84.67c1.14,2.5,17.55,52.36,17.55,55.47,0,3.46-3.32,5.8-16.15,11.39-1.76.76-3.46,1.51-5.08,2.23C179.14,302.7,173.48,305.12,170.77,305.13Zm19.68-75.61c-4.25,0-18.72,4.14-23.8,7.08h0c-.2.1-20.52,10.49-25.12,15.5-3.56,3.87-2.06,7.42-.31,11.54.43,1,.87,2.06,1.24,3.13,1.93,5.58,26.17,36,27.6,37.11s9.63-2.6,18.41-6.47l5.09-2.23c12-5.23,15.5-7.57,15.5-10.39,0-2.64-16.09-52-17.46-55C191.43,229.6,191,229.52,190.45,229.52Zm-24.07,6.61h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.73,277l13.77.55L156,273.93s-12.95-5.79-12.95-12.68,8-9.36,8-9.36l19.57-5.24L172,234.53c-.31,0-1.2,0-2.44.08a28.26,28.26,0,0,0-3.2,1.52s-20.55,10.48-25.28,15.62-1,9.86.82,15.2,25.93,35.93,27.78,37.37,11.3-3.08,24.05-8.63l.4-.18c-3.66.74-15.41,3.62-19.1.46-3.85-3.31-11.84-11.57-11.84-11.57l29.75.27Z",
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.73,277l13.77.55L156,273.93s-12.95-5.79-12.95-12.68,8-9.36,8-9.36l19.57-5.24L172,234.53c-.31,0-1.2,0-2.44.08a28.26,28.26,0,0,0-3.2,1.52s-20.55,10.48-25.28,15.62-1,9.86.82,15.2,25.93,35.93,27.78,37.37,11.3-3.08,24.05-8.63l.4-.18c-3.66.74-15.41,3.62-19.1.46-3.85-3.31-11.84-11.57-11.84-11.57l29.75.27Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.63,239.17a32.71,32.71,0,0,0,9.45,9.29c6.57,4.11,10.89,3.29,13.15-.83,1.85-3.36-1.11-13.32-2.25-16.83-5.67,1.54-11.91,3.77-14.6,5.33C166.38,236.13,164,237.35,160.63,239.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.61,251.7c-2.24,0-4.86-.93-7.82-2.78a33.67,33.67,0,0,1-9.61-9.45.52.52,0,0,1-.08-.43.56.56,0,0,1,.27-.35c3.32-1.8,5.74-3,5.76-3.05,2.62-1.51,8.68-3.72,14.7-5.37a.55.55,0,0,1,.66.36c1.31,4,4.14,13.77,2.21,17.27a6.87,6.87,0,0,1-4.3,3.58A7,7,0,0,1,177.61,251.7Zm-16.2-12.34a32.49,32.49,0,0,0,9,8.64c3.54,2.21,6.49,3,8.77,2.43a5.82,5.82,0,0,0,3.62-3.06c1.69-3.05-1-12.39-2.13-15.91-5.7,1.58-11.51,3.71-14,5.14C166.6,236.62,164.44,237.72,161.41,239.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.32,228.32a5.14,5.14,0,0,0-1.23,3.9c.41,2.06,2.47,10.07,2.26,12.74s-2.67,3.09-7.81,1-8.42-8-9.25-9.45-4.11-10.07-4.11-10.07l2.26-1.44s2.27,3.49,7.81,3.49,9.46-2.88,10.07-1.64S179.32,228.32,179.32,228.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.66,247.84a15.36,15.36,0,0,1-5.32-1.35c-3.44-1.37-6.61-4.59-9.45-9.56l-.07-.12c-.83-1.46-4-9.8-4.14-10.15a.55.55,0,0,1,.21-.65l2.26-1.44a.55.55,0,0,1,.75.16c.09.13,2.19,3.25,7.35,3.25a22.17,22.17,0,0,0,7-1.35c1.76-.58,3-1,3.54,0a2,2,0,0,1,.24,1.64,1,1,0,0,1-.37.46,4.51,4.51,0,0,0-1.06,3.37c.09.44.25,1.14.45,2,.74,3.26,2,8.71,1.82,10.89a2.81,2.81,0,0,1-1.26,2.35A3.55,3.55,0,0,1,177.66,247.84Zm-17.81-21.15c.66,1.73,3.22,8.37,3.91,9.58l.07.12c2.71,4.76,5.71,7.82,8.91,9.1,3.95,1.57,5.61,1.38,6.32.94a1.77,1.77,0,0,0,.75-1.51c.16-2-1.12-7.58-1.8-10.57-.2-.87-.36-1.58-.45-2a5.64,5.64,0,0,1,1.36-4.37.45.45,0,0,1,.13-.11,1.29,1.29,0,0,0-.21-.73,6.94,6.94,0,0,0-2.24.54,23.15,23.15,0,0,1-7.35,1.4,10.06,10.06,0,0,1-7.93-3.31Zm19.3,1.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.86,237.3l9.46-9-.3-1.69c-1.14-.41-4.79,1.89-9.77,1.89-5.54,0-7.81-3.49-7.81-3.49l-2.26,1.44s3.29,8.63,4.11,10.07,4.11,7.4,9.25,9.45c.52.21,1,.39,1.48.54Z",
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.86,237.3l9.46-9-.3-1.69c-1.14-.41-4.79,1.89-9.77,1.89-5.54,0-7.81-3.49-7.81-3.49l-2.26,1.44s3.29,8.63,4.11,10.07,4.11,7.4,9.25,9.45c.52.21,1,.39,1.48.54Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "150.76 219.68 155.07 225.23 160.62 222.97 156.51 215.37 150.76 219.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.07,225.77a.53.53,0,0,1-.42-.2L150.33,220a.55.55,0,0,1-.11-.41.58.58,0,0,1,.21-.36l5.76-4.31a.53.53,0,0,1,.44-.1.54.54,0,0,1,.36.27l4.11,7.6a.59.59,0,0,1,0,.45.51.51,0,0,1-.3.31l-5.55,2.26A.52.52,0,0,1,155.07,225.77Zm-3.55-6,3.73,4.79,4.61-1.88-3.53-6.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.16,222s-6.17-8.23-6-10.69,13.05-11.81,16.55-11.19,9,11.08,9,11.08l3.09,3.09-1,2.88s5.27,7.29,4.65,8.32-5.34,3.9-11.1,5.14-11.3-2.47-11.3-2.47-3.9,1.64-5.55.62-3.9-4.73-3.49-5.55S158.16,222,158.16,222Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.91,231.37a18.27,18.27,0,0,1-8.9-2.65c-1,.38-4.16,1.48-5.78.47s-4.34-5-3.7-6.25c.39-.79,2.56-1.21,4.63-1.44-1.6-2.2-5.69-8.07-5.5-10.29.12-1.5,3.33-4.18,5.23-5.65,3-2.29,9.29-6.5,12-6,3.58.63,8.61,9.9,9.34,11.29l3,3a.52.52,0,0,1,.12.57l-.93,2.61c3.52,4.89,5,7.81,4.52,8.68-.72,1.19-5.6,4.13-11.45,5.39A12.66,12.66,0,0,1,170.91,231.37Zm-8.85-3.8a.53.53,0,0,1,.3.09c.06,0,5.43,3.56,10.89,2.39,5.89-1.26,10.29-4.13,10.75-4.89.07-.68-2.34-4.56-4.63-7.72a.53.53,0,0,1-.07-.5l.91-2.56-2.85-2.84a.71.71,0,0,1-.1-.14c-1.49-2.84-6-10.33-8.61-10.8-1.62-.28-6.5,2.27-11.1,5.82-3.24,2.49-4.76,4.28-4.81,4.88-.14,1.65,3.51,7.21,5.85,10.32a.55.55,0,0,1,.06.55.52.52,0,0,1-.45.31c-2.25.2-4.42.64-4.72,1-.1.58,1.75,3.84,3.32,4.82,1.15.72,4.11-.26,5-.66A.52.52,0,0,1,162.06,227.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.36,230.58a31.89,31.89,0,0,0,6.54-2.2,4.93,4.93,0,0,1-.58-.06c-2.43-.49-9.46-2.07-12.18-5.47a28.37,28.37,0,0,0-4.08-4.43l15.22-6.73-.54-.54s-5.5-10.46-9-11.08-16.35,8.72-16.55,11.19,6,10.68,6,10.68-4.73.42-5.14,1.24,1.85,4.52,3.49,5.55,5.55-.62,5.55-.62S167.61,231.81,173.36,230.58Z",
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.36,230.58a31.89,31.89,0,0,0,6.54-2.2,4.93,4.93,0,0,1-.58-.06c-2.43-.49-9.46-2.07-12.18-5.47a28.37,28.37,0,0,0-4.08-4.43l15.22-6.73-.54-.54s-5.5-10.46-9-11.08-16.35,8.72-16.55,11.19,6,10.68,6,10.68-4.73.42-5.14,1.24,1.85,4.52,3.49,5.55,5.55-.62,5.55-.62S167.61,231.81,173.36,230.58Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.85,223.59l22.82,149.82,2.87-.41-22-149.62A5.38,5.38,0,0,0,228.85,223.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.67,374a.54.54,0,0,1-.54-.46L228.32,223.67a.55.55,0,0,1,.35-.59,5.82,5.82,0,0,1,4.1-.19.54.54,0,0,1,.32.42l22,149.61a.55.55,0,0,1-.1.41.58.58,0,0,1-.36.21l-2.88.41ZM229.46,224,252.12,372.8l1.81-.26L232.07,223.8A5.09,5.09,0,0,0,229.46,224Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.47,242.09s-4.52-1-4.52,1.64-.41,7.19,1.23,8.22,3.7.62,3.91-1.85S230.09,241.47,229.47,242.09Z",
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.88,253a3.78,3.78,0,0,1-2-.61c-1.65-1-1.58-4.37-1.51-7.31,0-.49,0-.95,0-1.37a2.1,2.1,0,0,1,.78-1.71c1.23-1,3.51-.64,4.22-.5a.65.65,0,0,1,.41,0c1.2.55.81,8.51.81,8.59a3,3,0,0,1-1.53,2.59A2.67,2.67,0,0,1,227.88,253Zm-.23-10.59a3,3,0,0,0-1.79.43,1,1,0,0,0-.37.87c0,.42,0,.9,0,1.39-.05,2.26-.12,5.67,1,6.37a2.26,2.26,0,0,0,2.15.28,1.94,1.94,0,0,0,.93-1.71,35.82,35.82,0,0,0-.27-7.46A8.14,8.14,0,0,0,227.65,242.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.12,253.27s-.16,3.23.46,3.55,8.91-.32,9.22-1,.16-3.23-.46-3.39S232.89,252.47,232.12,253.27Z",
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.76,257.45a4.16,4.16,0,0,1-1.43-.15c-.61-.32-.87-1.68-.75-4.05a.52.52,0,0,1,.14-.35c1.06-1.11,9.33-1.07,9.76-1a1.06,1.06,0,0,1,.66.64,5.75,5.75,0,0,1,.15,3.51,1.11,1.11,0,0,1-.7.49A38.74,38.74,0,0,1,233.76,257.45Zm-.89-1.11a38.23,38.23,0,0,0,8.48-.81,5.22,5.22,0,0,0-.22-2.55c-1-.13-7.24.1-8.48.6A8.71,8.71,0,0,0,232.87,256.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.68,249.07s-.2,4.11.58,4.52,11.37-.41,11.76-1.23.19-4.11-.59-4.31S230.66,248.05,229.68,249.07Z",
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.7,254.24a4.92,4.92,0,0,1-1.69-.17c-.9-.47-1-3-.88-5a.56.56,0,0,1,.15-.35c1.27-1.33,11.75-1.32,12.29-1.18a1.18,1.18,0,0,1,.74.73,7.31,7.31,0,0,1,.2,4.34,1.29,1.29,0,0,1-.81.56A51.6,51.6,0,0,1,231.7,254.24Zm-1.49-4.88a9.84,9.84,0,0,0,.34,3.78c.89.26,9.84-.44,11-1.09.27-.77.05-3.17-.33-3.51C240.26,248.34,231.66,248.66,230.21,249.36Zm11.4,2.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.27,244.55s-.21,4.11.61,4.52,11.92-.41,12.33-1.23.21-4.11-.61-4.32S230.29,243.52,229.27,244.55Z",
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.37,249.67a7.48,7.48,0,0,1-1.73-.11c-.94-.47-1-3-.92-5a.57.57,0,0,1,.16-.36c1.33-1.33,12.29-1.31,12.85-1.17a1.24,1.24,0,0,1,.79.77,7,7,0,0,1,.18,4.31C242.17,249.15,234.82,249.67,231.37,249.67Zm-1.58-4.82c-.06,1.77.1,3.49.37,3.76.89.27,10.41-.45,11.6-1.09.27-.75.05-3.18-.35-3.49C240.56,243.85,231.33,244.13,229.79,244.85Zm12,2.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.65,240s-.21,4.11.62,4.52,11.92-.41,12.33-1.23.2-4.11-.62-4.32S229.68,239,228.65,240Z",
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.75,245.15A7.54,7.54,0,0,1,229,245c-.94-.47-1-3-.91-5a.52.52,0,0,1,.16-.35c1.32-1.33,12.28-1.31,12.84-1.17a1.24,1.24,0,0,1,.79.77,7,7,0,0,1,.18,4.31C241.55,244.62,234.2,245.15,230.75,245.15Zm-1.57-4.82a9.37,9.37,0,0,0,.36,3.76c.9.27,10.42-.46,11.61-1.09.27-.75,0-3.18-.35-3.49C240,239.33,230.72,239.6,229.18,240.33Zm12,2.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.15,259.07c.28,6.2,5.65,10.61,9,12.76a9.18,9.18,0,0,0,5.11,1.46L213,272.5V259.35l-64.53-9s-5.13.2-6.51,4.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.12,273.83a9.67,9.67,0,0,1-5.28-1.55c-3.32-2.14-8.93-6.7-9.23-13.19a.55.55,0,0,1,.52-.57.53.53,0,0,1,.56.52c.28,6,5.59,10.31,8.74,12.33a8.39,8.39,0,0,0,4.81,1.38l59.25-.78V259.82l-64.07-9c.05,0-4.68.25-5.92,3.71a.54.54,0,0,1-.69.33.56.56,0,0,1-.33-.7c1.48-4.15,6.77-4.41,7-4.41l64.62,9a.55.55,0,0,1,.47.54V272.5a.54.54,0,0,1-.53.54l-59.79.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.5,250.31s-5.13.2-6.51,4.06l-2.84,4.7c.28,6.2,5.65,10.61,9,12.76a9.18,9.18,0,0,0,5.11,1.46L213,272.5v-10c-1.24-1.42-2.42-2.72-3.23-3.61l-1.37-.2-3.07,10.54s-35.82-.82-46.56-2.75-14.05-4.13-14.33-9.09A7.68,7.68,0,0,1,148.5,250.31Z",
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.5,250.31s-5.13.2-6.51,4.06l-2.84,4.7c.28,6.2,5.65,10.61,9,12.76a9.18,9.18,0,0,0,5.11,1.46L213,272.5v-10c-1.24-1.42-2.42-2.72-3.23-3.61l-1.37-.2-3.07,10.54s-35.82-.82-46.56-2.75-14.05-4.13-14.33-9.09A7.68,7.68,0,0,1,148.5,250.31Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.71,257.71,208.3,277,228,272.92s10.07.82,12.33.62,4.11-3.5,4.11-5.14v-3.7a3.56,3.56,0,0,0,1.44-2.88c-.2-1.64-3.49-2.67-3.49-2.67s-9.45-2.06-12.13-1.44S208.71,257.71,208.71,257.71Z",
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.3,277.57a.52.52,0,0,1-.34-.12.57.57,0,0,1-.2-.43l.41-19.32a.58.58,0,0,1,.17-.38.46.46,0,0,1,.39-.15c6.52.21,19.38.49,21.44,0,2.76-.64,12,1.36,12.36,1.44s3.68,1.2,3.92,3.13A3.91,3.91,0,0,1,245,265v3.45c0,1.8-2,5.43-4.61,5.68-2.19.2-11.33-.53-12.34-.61l-19.66,4.09Zm.94-19.3-.38,18.09,19.06-4h.16c.1,0,10,.81,12.23.62,1.95-.18,3.62-3.2,3.62-4.6v-3.7a.53.53,0,0,1,.22-.43s1.39-1.08,1.23-2.38c-.13-1-2.16-1.92-3.12-2.22-2.55-.55-9.75-1.92-11.84-1.43C227.93,258.81,212.43,258.37,209.24,258.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.09,222.15l34.52-15.82s1.44-1-.82-1.24a35.93,35.93,0,0,0-6.78.62s-7.29-10.37-8.73-10.78-2.26,0-2.46.83l-.21.82s-11.82,3.37-16.35,9.33S148.09,222.15,148.09,222.15Z",
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.09,222.69a.54.54,0,0,1-.48-.29c-.23-.43-5.45-10.65-.78-16.81,4.23-5.57,14.4-8.86,16.33-9.44l.13-.53a1.73,1.73,0,0,1,.82-1.11,3,3,0,0,1,2.32-.1c1.45.42,6.88,8,8.82,10.71a32.81,32.81,0,0,1,6.59-.57c.66.06,1.55.22,1.74.91s-.51,1.21-.65,1.31l-.09,0-34.53,15.82A.44.44,0,0,1,148.09,222.69Zm17.17-27.38a1.16,1.16,0,0,0-.6.14.65.65,0,0,0-.32.44l-.2.82a.55.55,0,0,1-.38.39c-.12,0-11.71,3.4-16.06,9.14-3.74,4.93-.3,13.16.64,15.2l34-15.58.11-.1a3.46,3.46,0,0,0-.7-.13,35.56,35.56,0,0,0-6.63.61.54.54,0,0,1-.54-.22c-3.49-5-7.6-10.26-8.44-10.57A3.39,3.39,0,0,0,165.26,195.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.76,212a.56.56,0,0,1-.46-.25c-.32-.5-3.14-5-3.14-7.1,0-1.91,2.59-3.53,3.73-4.15l-1.29-2.58a.54.54,0,1,1,1-.48l1.54,3.06a.55.55,0,0,1,0,.42.5.5,0,0,1-.28.31c-.93.45-3.6,2-3.6,3.42,0,1.54,2.15,5.22,3,6.51a.55.55,0,0,1-.17.75A.62.62,0,0,1,164.76,212Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.54,216.76a.57.57,0,0,1-.48-.28c-.11-.21-2.78-5.09-2.78-7.75a8.14,8.14,0,0,1,2-4.95.54.54,0,0,1,.76,0,.55.55,0,0,1,0,.77,7.12,7.12,0,0,0-1.73,4.22c0,2.38,2.63,7.17,2.65,7.22a.54.54,0,0,1-.21.74A.59.59,0,0,1,153.54,216.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.44,219.65a.54.54,0,0,1-.23-1l19.89-9.18a.54.54,0,0,1,.46,1l-19.9,9.19A.59.59,0,0,1,148.44,219.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.52,395c0-.58.07-1.17.07-1.76,0-14-13.15-25.33-29.38-25.33s-29.39,11.34-29.39,25.33c0,.59,0,1.18.08,1.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.52,395.57H225.9a.54.54,0,0,1-.54-.5c-.05-.68-.08-1.25-.08-1.8,0-14.26,13.43-25.87,29.93-25.87s29.93,11.61,29.93,25.87c0,.54,0,1.12-.08,1.8A.55.55,0,0,1,284.52,395.57Zm-58.12-1.08H284c0-.45,0-.84,0-1.22,0-13.67-12.94-24.78-28.84-24.78s-28.85,11.11-28.85,24.78C226.36,393.65,226.38,394.05,226.4,394.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.52,397.44c0-.59.07-1.17.07-1.76,0-14-13.15-25.33-29.38-25.33s-29.39,11.34-29.39,25.33c0,.59,0,1.17.08,1.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.52,398H225.9a.54.54,0,0,1-.54-.5c-.05-.68-.08-1.26-.08-1.8,0-14.27,13.43-25.87,29.93-25.87s29.93,11.6,29.93,25.87c0,.54,0,1.11-.08,1.8A.55.55,0,0,1,284.52,398Zm-58.12-1.09H284c0-.44,0-.84,0-1.21,0-13.67-12.94-24.79-28.84-24.79S226.36,382,226.36,395.68C226.36,396.06,226.38,396.45,226.4,396.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.21,370.35c-10,0-18.83,4.31-24.14,10.89l6.89,5.44a21.05,21.05,0,0,1,32.78,0l9-5C274.44,374.85,265.43,370.35,255.21,370.35Z",
    style: {
      fill: "#CD7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.74,387.23a.51.51,0,0,1-.42-.21,20.51,20.51,0,0,0-31.94,0,.54.54,0,0,1-.75.09l-6.9-5.45a.54.54,0,0,1-.2-.36.58.58,0,0,1,.12-.4c5.6-6.94,14.78-11.09,24.56-11.09,10,0,19.35,4.32,24.92,11.54a.58.58,0,0,1,.1.44.54.54,0,0,1-.27.37l-9,5A.59.59,0,0,1,270.74,387.23Zm-16.39-8.93A21.49,21.49,0,0,1,270.87,386l8-4.47c-5.41-6.67-14.2-10.63-23.67-10.63-9.25,0-17.94,3.83-23.37,10.27l6,4.77A21.53,21.53,0,0,1,254.35,378.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.23,396.69a8.93,8.93,0,0,0-17.85,0c0,.25,0,.5,0,.75h17.77C263.21,397.19,263.23,396.94,263.23,396.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.19,398H245.42a.55.55,0,0,1-.54-.5c0-.26,0-.52,0-.79a9.47,9.47,0,0,1,18.93,0c0,.27,0,.53,0,.79A.54.54,0,0,1,263.19,398Zm-17.26-1.09h16.76v-.2a8.38,8.38,0,0,0-16.76,0Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/Loading.656848cceee1ec47e0d03d374edea6c9.svg";
export { ForwardRef as ReactComponent };